export const monteregie = {
  logo_image_url: 'monteregie.png',
  header_full_height: true,

  body_background_color: '#00afef',

  button_color: '#004270',
  button_radius: 13,
  button_half_border_color: '#004270',

  text_font: `'Roboto', sans-serif`,
}

export const monteregieCalendrier = {
  logo_image_url: 'vireesgourmandes.png',
  logo_height: 400,

  body_background_color: '#347558',

  button_color: '#347558',
  button_half_border_color: '#347558',
  button_radius: 13,
  number_hidden: true,
  token_hidden: true,

  text_font: `'Montserrat', sans-serif`,
}
